import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { object, ObjectSchema } from "yup";
import { Account } from "../../models/account";
import {
  accountValidationSchemaBase,
  CreateAccountFormValues,
} from "./create-account-form";

export type EditAccountFormValues = Omit<
  CreateAccountFormValues,
  "password" | "repeatPassword" | "termsOfService" | "acknowledged"
>;

const editAccountValidationSchema: ObjectSchema<EditAccountFormValues> = object({
  ...accountValidationSchemaBase,
})
  .required();

export function useEditAccountForm(account?: Account) {
  return useForm<EditAccountFormValues>({
    resolver: yupResolver(editAccountValidationSchema),
    /* comment out above resolver if form isn't submitting and uncomment this block to debug
    resolver: async (data, context, options) => {
      // you can debug your validation schema here
      console.log("formData", data)
      console.log(
        "validation result",
        await yupResolver(editAccountValidationSchema)(data, context, options)
      )
      return yupResolver(editAccountValidationSchema)(data, context, options)
    },*/
    reValidateMode: "onChange",
    mode: "onChange",
    defaultValues: {
      firstName: account?.firstName,
      lastName: account?.lastName,
      county: account?.county,
      municipality: account?.municipality,
      email: account?.email,
      phone: account?.phone,
      streetAddress: account?.address1,
      aptSuiteBuilding: account?.address2,
      city: account?.city,
      state: account?.state.id,
      zipCode: account?.postalCode,
    },
  });
}
